import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createDocumentsSlice } from './slice';
import type { DocumentsStoreState } from './types';

export const useDocumentsStore = createSelectors(
  create<DocumentsStoreState>()(withDevtools(createDocumentsSlice, StoreName.Documents))
);
